import React from 'react';
import classNames, { Argument } from 'classnames';
import { Card, makeStyles } from 'housecall-ui';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

type StyleProps = {
  selected: boolean;
};

const useStyles = makeStyles((theme: HCPTheme) => ({
  card: {
    color: ({ selected }: StyleProps) => (selected ? theme.palette.primary.main : theme.palette.brandPrimary.main),
    border: ({ selected }: StyleProps) => (selected ? `1px solid ${theme.palette.primary.main}` : 'none'),
    '&:hover': {
      color: theme.palette.primary.main,
    },
    overflow: 'hidden',
  },
  button: {
    color: ({ selected }: StyleProps) => (selected ? theme.palette.primary.main : theme.palette.brandPrimary.main),
    textTransform: 'none',
    height: '100%',
    width: '100%',
    minWidth: '0',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'inherit',
    },
  },
}));

type Props = {
  selected?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  classes?: {
    card?: Argument;
    button?: Argument;
  };
  className?: Argument;
};

export const SmallCardButton = ({ selected = false, onClick, children, classes, className }: Props) => {
  const { card, button } = useStyles({ selected });

  return (
    <Card className={classNames(card, classes?.card, className)}>
      <Button onClickCapture={onClick} className={classNames(button, classes?.button)}>
        {children}
      </Button>
    </Card>
  );
};
